import { useContext, useMemo } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { ActiveChatSessionContext, SubmitMessageContext } from '../context';

export function useCancelQueryMutation() {
  const apiClient = useChatApiClient();

  const chat = useContext(ActiveChatSessionContext);
  const dispatch = useContext(ChatStateDispatchContext);

  const { state } = useContext(SubmitMessageContext);

  const queryIdentifier = useMemo(() => {
    if (state.status !== 'submitting-query') {
      return null;
    }
    return state.queryIdentifier;
  }, [state]);

  return useMutation({
    mutationFn: () => {
      if (!queryIdentifier) {
        return;
      }
      return apiClient.queries.cancelQuery({
        chatId: chat.id, queryIdentifier,
      });
    },
    onSuccess: () => {
      if (!queryIdentifier) {
        return;
      }
      dispatch({
        type: 'query-cancelled',
        payload: { queryIdentifier },
      });
    },
  });
}
